import { ChangeEvent, useCallback, useState } from 'react';

type UseOnInputChangeReturn<T> = [
  T,
  (event: ChangeEvent<HTMLInputElement>) => void,
  (value: T) => void
];

export function useOnInputChange<T> (defaultValue: T): UseOnInputChangeReturn<T> {
  const [value, setValue] = useState<T>(defaultValue);

  const onInputChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value as any);
  }, []);

  return [value, onInputChange, setValue];
}
